import { Modal } from 'antd'
import { useLogout } from 'Hooks/useLogout'
import TipsyButton from 'Comps/ui-kit/TipsyButton'
import useI18n from 'Hooks/useI18n'
type LogOutDialogProps = {
  visible: boolean
  onClose: () => void
}
export default function LogOut({ visible, onClose }: LogOutDialogProps) {
  const { t } = useI18n()
  const { logout } = useLogout()
  const handleLogout = () => {
    logout()
    onClose()
  }
  return (
    <Modal
      open={visible}
      className="pointer-events-auto rounded-[10px] border border-primary-border bg-white/20 p-0 text-primary-text"
      styles={{
        content: { background: 'transparent', boxShadow: 'none' },
      }}
      style={{
        background:
          'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(87,47,102,0.8) 50%, rgba(29,21,21,0.8) 100%)',
        paddingBottom: 0,
        top: '-5%',
      }}
      transitionName=""
      width={368}
      centered={true}
      closeIcon={false}
      footer={null}
      onCancel={() => onClose()}
    >
      <div className="select-none text-center text-lg font-medium text-primary-text">
        {t('Log out')}
      </div>
      <div className="my-[46px] text-center text-base text-primary-text">
        {t('Are you sure you want to log out?')}
      </div>
      <div className="flex text-center text-base text-primary-text">
        <TipsyButton
          className="mr-[5px] h-[42px] w-3/6"
          variant="outlined"
          onClick={() => onClose()}
        >
          {t('Cancel')}
        </TipsyButton>
        <TipsyButton
          className="ml-[5px] h-[42px] w-3/6"
          variant="filled"
          onClick={handleLogout}
        >
          {t('Log out')}
        </TipsyButton>
      </div>
    </Modal>
  )
}
